// src/About.js
import React from "react";
import "./Sections.css";
import { tUI } from "./i18n";

export function About({ language }) {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-[900px] px-4 pt-24 pb-16">
        {/* Title */}
        <h2 className="text-center text-[32px] md:text-[36px] font-bold tracking-tight text-slate-900 mb-6">
          {tUI(language, "about_title")}
        </h2>

        {/* Intro – with bold parts */}
        <p className="text-[15px] leading-7 text-slate-600 mb-4">
          <span className="font-semibold">
            {tUI(language, "about_brand_name")}
          </span>{" "}
          {tUI(language, "about_intro_1_rest")}
        </p>

        <p className="text-[15px] leading-7 text-slate-600 mb-8">
          {tUI(language, "about_intro_2_part1")}{" "}
          <span className="font-semibold">
            {tUI(language, "about_intro_2_languages")}
          </span>
          {" "}
          {tUI(language, "about_intro_2_part2")}
        </p>

        {/* ───────── SERVICE CARDS (unchanged) ───────── */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {/* Smart CV Conversion */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-[18px] font-semibold text-slate-900 mb-2">
              {tUI(language, "about_block_ats_title")}
            </h3>
            <p className="text-[14px] leading-6 text-slate-600">
              {tUI(language, "about_block_ats_body")}
            </p>
          </div>

          {/* AI-Enhanced CV Matching */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-[18px] font-semibold text-slate-900 mb-2">
              {tUI(language, "about_block_ai_title")}
            </h3>
            <p className="text-[14px] leading-6 text-slate-600">
              {tUI(language, "about_block_ai_body")}
            </p>
          </div>

          {/* Premium CV Builder */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-[18px] font-semibold text-slate-900 mb-2">
              {tUI(language, "about_block_builder_title")}
            </h3>
            <p className="text-[14px] leading-6 text-slate-600">
              {tUI(language, "about_block_builder_body")}
            </p>
          </div>

          {/* Free ATS Scan */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-[18px] font-semibold text-slate-900 mb-2">
              {tUI(language, "about_block_free_title")}
            </h3>
            <p className="text-[14px] leading-6 text-slate-600">
              {tUI(language, "about_block_free_body")}
            </p>
          </div>
        </div>

       {/* Mission */}
      <p className="text-[15px] leading-7 text-slate-600 mb-8">
      <span className="font-semibold">
        {tUI(language, "about_mission_bold")}
      </span>{" "}
      {tUI(language, "about_mission_rest")}
      </p>


        {/* Contact block */}
        <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-6 text-[14px] leading-6 text-slate-700">
          <h3 className="text-[16px] font-semibold mb-2 text-slate-900">
            {tUI(language, "about_contact_title")}
          </h3>
          <p className="mb-3">
            <span className="font-semibold">
              {tUI(language, "about_contact_email_label")}
            </span>{" "}
            <a
              href="mailto:contact@yoursmartcv.com"
              className="text-indigo-600 hover:text-indigo-500 underline"
            >
              contact@yoursmartcv.com
            </a>
          </p>

          <h4 className="text-[14px] font-semibold mb-1 text-slate-900">
            {tUI(language, "about_address_title")}
          </h4>
          <p>
            YourSmartCV – Ly Insights
            <br />
            Mühlenstr. 8a
            <br />
            14167 Berlin
            <br />
            Germany
          </p>
        </div>
      </div>
    </section>
  );
}
